export const LABEL_PUSH_PIN = 'push pin';
export const LABEL_EXCLUSIVE = 'exclusive';
export const LABEL_HOT_DEAL = 'hot deal';
export const LABEL_LICENSED = 'officially licensed';
